module.exports = __webpack_public_path__ + "img/IK_symbol.df04ce33.svg";